import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const useLegacyWorkflow = ({
  workflowId
}: {
  workflowId: string | null
}) => {
  const query = useQuery(
    dashboardv99990101Client.getWorkflow,
    { workflowId: workflowId ?? '' },
    { enabled: !!workflowId }
  )

  return {
    workflow: query.data,
    isPending: !!workflowId && query.isPending
  }
}
